// Section-family stylesheets (scripts/style-families). The build links each
// family only from the pages whose HTML uses it and embeds the manifest of
// all families in every page, so a page that renders sections the build did
// not see (client-side navigation, the preview page) links them from here.
const readStyleFamilies = () => {
  if (process.env.NODE_ENV === 'development') return [];
  const manifest = document.getElementById('style-families');
  if (!manifest) return [];
  try {
    return Object.values(JSON.parse(manifest.textContent));
  } catch (_) {
    return [];
  }
};

export const unlinkedStyleFamilies = () => {
  const linked = new Set(
    Array.from(document.querySelectorAll('link[data-style-family]')).map((link) => link.getAttribute('href'))
  );
  return readStyleFamilies().filter(({ href }) => !linked.has(href));
};

// Links every family not yet linked, in the same position relative to the
// global sheet as the build gives them.
export const applyStyleFamilies = () => {
  const inlineSheet = document.querySelector('[data-identity="gatsby-global-css"]');
  for (const { href, placement } of unlinkedStyleFamilies()) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.styleFamily = 'true';
    if (placement === 'before' && inlineSheet) document.head.insertBefore(link, inlineSheet);
    else document.head.appendChild(link);
  }
};
